import React from 'react';

const RELOAD_GUARD_KEY = 'ls:chunk-reload-at';
const RELOAD_GUARD_WINDOW_MS = 10000;

export const isChunkLoadError = (err) => {
  const message = String((err && (err.message || err)) || '').toLowerCase();
  return (
    message.includes('loading chunk') ||
    message.includes('chunkloaderror') ||
    message.includes('dynamically imported module') ||
    message.includes('importing a module script failed') ||
    message.includes('expected a javascript')
  );
};

export const reloadOnceForStaleChunk = () => {
  try {
    if (typeof window === 'undefined') return false;

    const last = Number(window.sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
    if (Date.now() - last > RELOAD_GUARD_WINDOW_MS) {
      window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
      window.location.reload();
      return true;
    }
  } catch {
    // Storage can be unavailable in private mode. Let the original error surface.
  }

  return false;
};

export default function lazyWithRetry(factory, retries = 1, interval = 400) {
  return React.lazy(() => {
    const attempt = (remaining) => factory().catch((err) => {
      if (!isChunkLoadError(err)) throw err;

      if (remaining > 0) {
        return new Promise((resolve) => { setTimeout(resolve, interval); })
          .then(() => attempt(remaining - 1));
      }

      if (reloadOnceForStaleChunk()) {
        return new Promise(() => {});
      }

      throw err;
    });

    return attempt(retries);
  });
}
